import _ from "lodash";
import {
  DATA_GRID_COLUMN_TYPES,
  EMPTY_CELL_WITH_CENTERED_DASH,
} from "../constants";

const getIconCellProps = ({
  node,
  cellConfig,
  customConfig,
  columnId,
  actionHandlerFn,
}) => {
  const { styles } = cellConfig || {};
  const {
    property,
    showEmptyCellAsFallback = false,
    negatedValue = false,
    affirmativeIcon,
    negativeIcon,
    dependentProperties = [],
    getCellConfigFromValue,
  } = customConfig || {};

  switch (columnId) {
    case DATA_GRID_COLUMN_TYPES.DEPTH_ADJUSTER: {
      return {
        ...cellConfig,
        value: [
          {
            name: "ChevronLeftOutlined",
            onIconClick: params => {
              actionHandlerFn({ ...params, action: "outdent" });
            },
          },
          {
            name: "ChevronRightOutlined",
            onIconClick: params => {
              actionHandlerFn({ ...params, action: "indent" });
            },
          },
        ],
      };
    }
    case DATA_GRID_COLUMN_TYPES.LOCK: {
      const value = _.get(node, property);
      const areDependentPropertiesSatisfied = _.every(
        dependentProperties,
        prop => _.get(node, prop)
      );

      if (showEmptyCellAsFallback && !areDependentPropertiesSatisfied) {
        return {
          ...EMPTY_CELL_WITH_CENTERED_DASH,
          styles: { align: "center", ...styles },
        };
      }

      const tooltip = value
        ? _.get(cellConfig, "tooltip")
        : _.get(customConfig, "negativeIconTooltip");

      const valueToCellConfig = _.isFunction(getCellConfigFromValue)
        ? getCellConfigFromValue({ node, value })
        : {};

      return {
        ...cellConfig,
        tooltip,
        value: value ? affirmativeIcon : negativeIcon,
        ...valueToCellConfig,
      };
    }
    default: {
      break;
    }
  }

  const { value: cellValue } = cellConfig || {};

  const value = _.get(node, property);
  const updatedValue = negatedValue ? !value : !!value;

  if (!updatedValue && showEmptyCellAsFallback) {
    return {
      ...EMPTY_CELL_WITH_CENTERED_DASH,
      styles: {
        align: "center",
        ...styles,
      },
    };
  }

  return {
    ...cellConfig,
    value: cellValue
      ? cellValue
      : updatedValue
      ? affirmativeIcon
      : negativeIcon,
  };
};

export default getIconCellProps;
